let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e8xIh")).then(() => parcelRequire('40nKs'));